export const properties = {
  categories: [
    "baking",
    "pasta",
    "spieces",
    "vegetables and fruits",
    "meat and more",
    "dairy",
    "sweets",
    "beverages",
    "others",
  ],

  units: ["piece", "liter", "kilogram"],
};
